/**
 * 評価計算設定ページ用のスクリプト
 */
if (is_route('evaluation.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        evaluation_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.evaluation_event_set = function() {
    let settingModalId = '#evaluation-setting-modal';
    let detailModalId = '#evaluation-detail-modal';

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        // 同じbladeを使用しているので、ステッパーの処理をうまく動作させるために、空にする
        $(detailModalId).find('.modal-content').empty();
        _modal.create(this, 'setting-modal', ['id', 'holding_id', 'company_id'], false, function () {
            // 車両割り付け編集可否の為、初期化
            // initialize_tree_multiselect();
            initialize('tree-multiselect');
        });
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        evaluation_set_stepper_error(false);

        _modal.submit(this, 'save-modal', null, function (xhr) {
            // ステップエラーを表示
            evaluation_set_stepper_error(true);
        });
    });

    /*---- 削除確認の表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-confirm-modal]', function () {
        // 設定モーダルを表示
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

    /*---- 詳細表示時 ----*/

    // 詳細表示時
    $(document).on('click', '[data-detail-modal]', function () {
        // 同じbladeを使用しているので、ステッパーの処理をうまく動作させるために、空にする
        $(settingModalId).find('.modal-content').empty();
        _modal.create(this, 'detail-modal', ['id', 'holding_id', 'company_id'], false, function () {
            // 車両割り付け編集可否の為、初期化
            initialize_tree_multiselect();
        });
    });

    /*---- ステップボタンクリック時（新規登録時） ----*/

    // 前へ
    $(document).on('click', '[data-prev-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let prevPart = $(this).data('prev-step');
        let prevPartTrigger = create_id(prevPart + '-trigger');
        let prevPartSubmit = create_id(prevPart + '-submit');
        $(currentPartSubmit).addClass('display-none');
        $(prevPartSubmit).removeClass('display-none');
        bs_step_trigger(prevPartTrigger);

        // 別ステップ移動時に、bs_step_trigger関数で、元々開いていたnav-tabsコンテンツのshowクラスが消えるので追加
        let firstNav = $('#baseNavTab [data-toggle="tab"]:first');
        $('#baseNavTab [data-toggle="tab"]').removeClass('active');
        firstNav.addClass('active');
        let contentId = firstNav.attr('href');
        $(contentId).addClass('show').addClass('active');
    });

    // 次へ
    $(document).on('click', '[data-next-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let nextPart = $(this).data('next-step');
        let currentPart = $(this).data('confirm-step');
        let nextPartTrigger = create_id(nextPart + '-trigger');
        let nextPartSubmit = create_id(nextPart + '-submit');
        // ModalとPartセレクターの指定
        let modalId = settingModalId;
        let formId = modalId + '-form';
        let action = $(formId).data('confirm-action');
        // 確認対象のパートをパラメータにセット
        $(modalId + '-confirm_step').val(currentPart);

        evaluation_set_stepper_error(false);

        // 送信前にエラーをリセット
        _error.reset()
        // 確認用のpost送信
        _ajax.confirm_submit(formId, action, function (results) {
            $(currentPartSubmit).addClass('display-none');
            $(nextPartSubmit).removeClass('display-none');
            bs_step_trigger(nextPartTrigger);
        }, function(xhr, status, errorThrown) {
            // エラーをセットする
            _error.set(modalId, xhr, status, errorThrown);
            // ステップエラーを表示
            evaluation_set_stepper_error(true);
        });
    });

    /**
     * ステッパーへのエラー表示処理
     * @param {*} showError
     */
    function evaluation_set_stepper_error(showError = true) {
        if (showError) {
            $('#base-part-trigger').toggleClass('error', ($('#base-part').find('.invalid-feedback:not(.copy)').length > 0));
            $('#ratio-part-trigger').toggleClass('error', ($('#ratio-part').find('.invalid-feedback:not(.copy)').length > 0));
            $('#vehicle-part-trigger').toggleClass('error', ($('#vehicle-part').find('.invalid-feedback:not(.copy)').length > 0));
        } else {
            $('#base-part-trigger').removeClass('error');
            $('#ratio-part-trigger').removeClass('error');
            $('#vehicle-part-trigger').removeClass('error');
        }
    }
}
